import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';

// Prevent stale OIDC session when backend was stopped during development
// DEV: prevent stale oidc-client session after backend restart
if (process.env.NODE_ENV === "development") {

    const resetFlag = "oidc-dev-reset-done";
    const path = window.location.pathname.toLowerCase();

    const isCallback =
        path.includes("login-callback") ||
        path.includes("logout-callback");

    // Only run once per browser session AND never during callback
    if (!sessionStorage.getItem(resetFlag) && !isCallback) {

        const prefix = "EyeThrive";

        for (const key of Object.keys(localStorage)) {
            if (key.startsWith(prefix)) {
                localStorage.removeItem(key);
            }
        }

        for (const key of Object.keys(sessionStorage)) {
            if (key.startsWith(prefix)) {
                sessionStorage.removeItem(key);
            }
        }

        sessionStorage.setItem(resetFlag, "true");
        console.log("DEV MODE: cleared stale OIDC session (once)");
    }
}

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
  rootElement);

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//
//registerServiceWorker();

